<form [formGroup]="form" (ngSubmit)="submit(form)" errorTailor>
    <div class="modal-header">
        <h4 class="modal-title">{{modalTitle}}</h4>
    </div>
    <div class="modal-body">
        <div>
            <span>
                <input
                    type="text"
                    class="form-control"
                    placeholder="Choose title for the item" 
                    formControlName="title" />
            </span>
            <div class="form-group duplicate-roster" *ngIf="!isTemplate && !toTemplate && availability === QuestionnaireMasterAvailability.COMPLIANCE_ITEMS">
                <br />
                <div><label class="form-label">Duplicate Roster:</label></div>
                <toggle-indicator formControlName="shouldDuplicateRoster" OnLabel="Yes" OffLabel="No"></toggle-indicator>
            </div>
            <ul *ngIf="questionnaireSections.length > 0" formArrayName="sections">
                <li *ngFor="let section of questionnaireSections; index as sectionIndex" [formGroupName]="sectionIndex">
                    <div *ngIf="section.questionnaires?.length > 0">
                        <hr>
                        <div class="m-4">
                            <h5 class="table-title">{{section.title}}</h5>
                            <table class="table table-striped expandable-rows">
                                <thead style="width: 100%">
                                    <th style="width: 35%">Current Questionnaire</th>
                                    <th style="width: 25%">Action</th>
                                    <th style="width: 40%"></th>
                                </thead>
                                <tbody style="width: 100%" formArrayName="questionnaires">
                                    <tr *ngFor="let questionnaire of section.questionnaires; index as qfmIndex" [formGroupName]="qfmIndex">
                                        <td style="width: 35%">
                                            <label class="form-label">{{questionnaire.QfmTitle}}</label>
                                        </td>
                                        <td style="width: 25%">
                                            <select class="form-select" formControlName="action">
                                                <option *ngIf="toTemplate === questionnaire.IsTemplate" [value]="DuplicateItemActions.KEEP">Use Current Questionnaire</option>
                                                <option *ngIf="toTemplate !== questionnaire.IsTemplate" [value]="DuplicateItemActions.DUPLICATE">
                                                    {{toTemplate ? 'Convert to Template as' : 'Duplicate Questionnaire as'}}
                                                </option>
                                                <option *ngIf="toTemplate !== questionnaire.IsTemplate" [value]="DuplicateItemActions.REPLACE">Replace Questionnaire with</option>
                                                <option [value]="DuplicateItemActions.REMOVE">Do Not Use Questionnaire</option>
                                            </select>
                                        </td>
                                        <td style="width: 40%">
                                            <div *ngIf="getQuestionnaireField(sectionIndex, qfmIndex, 'action').value == DuplicateItemActions.DUPLICATE">
                                                <input type="text"
                                                    [ngClass]="{ 'ng-invalid': getQuestionnaireErrors(sectionIndex, qfmIndex, 'duplicateQfmTitleRequired') }"
                                                    class="form-control"
                                                    placeholder="Set Title for Duplicate Form" 
                                                    formControlName="duplicateQfmTitle" />
                                            </div>
                                            <ng-select
                                                *ngIf="questionnaires && getQuestionnaireField(sectionIndex, qfmIndex, 'action').value == DuplicateItemActions.REPLACE"
                                                placeholder="Select a Questionnaire"
                                                formControlName="newQfmId"
                                                [searchable]="true">
                                                <ng-option *ngFor="let qfm of questionnaires" [value]="qfm.FormID">{{qfm.Title}}</ng-option>
                                            </ng-select>
                                        </td>    
                                    </tr>
                                </tbody>
                            </table>
                        </div>
                    </div>
                </li>
            </ul>
        </div>
    </div>
    <div class="modal-footer">
        <button type="submit" [disabled]="form.invalid" class="btn btn-primary submit-button">Submit</button>
        <button type="button" class="btn btn-info cancel-button" (click)="activeModal.dismiss()">Cancel</button>
    </div>
</form>
